<script>

	import ImgLoad from '@/components/ImgLoad'

	export default {
		props: {
			bgImage: String
		},
		render () {
			const style = {
				backgroundImage: `url('${this.bgImage}')`
			}
			return (
				<ImgLoad
					url={this.bgImage}
					render={({ ready }) => (
						<div class={['masthead', { ready }]} style={style}>
							<div class="content">
								<div class="headline">
									<h1>{this.$slots['headline']}</h1>
									<h3>{this.$slots['sub-headline']}</h3>
								</div>
							</div>
						</div>
					)}
				/>
			)
		}
	}

</script>

<style lang="scss" scoped>

	@import "responsive-font";
	@import "media";

	.masthead {
		display:flex; flex:1; align-items:flex-end; justify-content:center; position:relative; min-height:42vw; padding:10rem 2rem 0; text-align:center; overflow:hidden; background-position:center; background-size:cover; opacity:0; transition:opacity .3s;
		@include media(small, large) {
			padding:20rem 2rem 1rem; height:auto;
		}
		&.ready {
			opacity:1;
		}
		&:before {
			position:absolute; left:0; right:0; top:0; bottom:0; background:linear-gradient(to top, rgba(#333, 1) 0%, rgba(#000, .4) 40%, rgba(#000, 0) 100%); content:'';
		}
		// img {
		// 	max-width:100%; max-height:100%; min-width:100%; min-height:100%; object-fit:cover; position:absolute; top:0; left:0; bottom:0; right:0; z-index:-1;
		// }

		.content {
			position: relative; width:100%;
		}

		.headline {
			max-width:85.9rem; margin:0 auto 2.2rem; position:relative;
			@include media(large) {
				padding-bottom:10.6rem;
			}
		}
		h1, h3 {
			color:#ffffff; font-weight:400; text-transform:uppercase;
		}
		h1 {
			@include responsive-font(50);
			line-height:1.16; margin-bottom:.2rem;
			@include media(small, large) {
				@include responsive-font(30);
			}
		}
		h3 {
			@include responsive-font(18.3);
			line-height:1.13;
		}
	}

</style>



// WEBPACK FOOTER //
// src/layouts/layoutB/masthead.vue